// Home Analytics Repository Implementation

import {HomeAnalyticsAPIDataSource} from '../api/HomeAnalyticsAPIDataSource';
import {
  mapInventoryProducts,
  mapStoresUsers,
  mapVisits
} from '../mappers/homeAnalytics.mapper';
import type {HomeAnalyticsRepository} from './HomeAnalyticsRepository';
import type {
  InventoryProductsAnalytics,
  StoresUsersAnalytics,
  VisitsAnalytics
} from '../models/homeAnalytics.model';

export class HomeAnalyticsRepositoryImpl implements HomeAnalyticsRepository {
  async getInventoryProductsAnalytics (): Promise<InventoryProductsAnalytics> {
    const [inventory, products] = await Promise.all([
      HomeAnalyticsAPIDataSource.getInventoryStatistics(),
      HomeAnalyticsAPIDataSource.getProductsStats()
    ]);
    return mapInventoryProducts(inventory, products);
  }

  async getVisitsAnalytics (): Promise<VisitsAnalytics> {
    const overview = await HomeAnalyticsAPIDataSource.getVisitsOverview();
    return mapVisits(overview);
  }

  async getStoresUsersAnalytics (): Promise<StoresUsersAnalytics> {
    const [stores, users] = await Promise.all([
      HomeAnalyticsAPIDataSource.getStoresStatistics(),
      HomeAnalyticsAPIDataSource.getUsersStatistics()
    ]);
    return mapStoresUsers(stores, users);
  }
}
